import AssignmentIcon from '@mui/icons-material/Assignment'
import FlipToBackIcon from '@mui/icons-material/FlipToBack'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import PersonIcon from '@mui/icons-material/Person'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import RestoreIcon from '@mui/icons-material/Restore'
import InventoryIcon from '@mui/icons-material/Inventory'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat'
import CloseIcon from '@mui/icons-material/Close'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import MuiSearchIcon from '@mui/icons-material/Search'
import MuiArrowBackIos from '@mui/icons-material/ArrowBackIos'
import MuiMemory from '@mui/icons-material/Memory'
import MuiFolderOpen from '@mui/icons-material/FolderOpen'
import MuiAccountCircle from '@mui/icons-material/AccountCircle'
import MuiZoomIn from '@mui/icons-material/ZoomIn'
import MuiPhotoLibrary from '@mui/icons-material/PhotoLibrary'
import MuiFilterTiltShift from '@mui/icons-material/FilterTiltShift'
import MuiRequestPage from '@mui/icons-material/RequestPage'
import MuiShoppingBag from '@mui/icons-material/ShoppingBag'
import MuiStraighten from '@mui/icons-material/Straighten'
import MuiLeaderboard from '@mui/icons-material/Leaderboard'
import MuiPhone from '@mui/icons-material/Phone'
import MuiEmail from '@mui/icons-material/Email'
import MuiTextsms from '@mui/icons-material/Textsms'
import MuiLocationOn from '@mui/icons-material/LocationOn'
import MuiGetApp from '@mui/icons-material/GetApp'
import MuiFilterList from '@mui/icons-material/FilterList'
import MuiHelp from '@mui/icons-material/Help'
import MuiMic from '@mui/icons-material/Mic'
import MuiStar from '@mui/icons-material/Star'
import MuiStarBorder from '@mui/icons-material/StarBorder'
import MuiWarning from '@mui/icons-material/Warning'
import MuiArrowForward from '@mui/icons-material/ArrowForward'
import MuiLaunch from '@mui/icons-material/Launch'
import MuiTurnedInNot from '@mui/icons-material/TurnedInNot'
import MuiUnforldMore from '@mui/icons-material/UnfoldMore'
import MuiOpenInNew from '@mui/icons-material/OpenInNew'
import MuiContentCopy from '@mui/icons-material/ContentCopy'
import MuiCheck from '@mui/icons-material/Check'
import MuiEast from '@mui/icons-material/East'
import MuiAutoAwesome from '@mui/icons-material/AutoAwesome'
import MuiOpenInFullOutlined from '@mui/icons-material/OpenInFullOutlined'
import MuiBlock from '@mui/icons-material/Block'
import MuiErrorOutline from '@mui/icons-material/ErrorOutline'
import MuiLocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined'
import MuiNotificationsOutlined from '@mui/icons-material/NotificationsOutlined'
import MuiFileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined'
import MuiRefresh from '@mui/icons-material/Refresh'

import { type SvgIconComponent } from '@mui/icons-material'
import type { SvgIconProps } from '@mui/material'

export const Assignment = AssignmentIcon
export const FlipToBack = FlipToBackIcon
export const MoreVert = MoreVertIcon
export const Person = PersonIcon
export const KeyboardArrowDown = KeyboardArrowDownIcon
export const KeyboardArrowUp = KeyboardArrowUpIcon
export const KeyboardArrowLeft = KeyboardArrowLeftIcon
export const KeyboardArrowRight = KeyboardArrowRightIcon
export const ExpandMore = ExpandMoreIcon
export const ArrowBack = ArrowBackIcon
export const CheckCircle = CheckCircleIcon
export const Cancel = CancelIcon
export const Fullscreen = FullscreenIcon
export const Restore = RestoreIcon
export const Inventory = InventoryIcon
export const Add = AddIcon
export const Edit = EditIcon
export const Delete = DeleteIcon
export const KeyboardReturn = KeyboardReturnIcon
export const TrendingUp = TrendingUpIcon
export const TrendingDown = TrendingDownIcon
export const TrendingFlat = TrendingFlatIcon
export const Close = CloseIcon
export const QrCodeScanner = QrCodeScannerIcon
export const SearchIcon = MuiSearchIcon
export const ArrowBackIos = MuiArrowBackIos
export const Memory = MuiMemory
export const FolderOpen = MuiFolderOpen
export const AccountCircle = MuiAccountCircle
export const ZoomIn = MuiZoomIn
export const PhotoLibrary = MuiPhotoLibrary
export const FilterTiltShift = MuiFilterTiltShift
export const RequestPage = MuiRequestPage
export const ShoppingBag = MuiShoppingBag
export const Straighten = MuiStraighten
export const Leadboard = MuiLeaderboard
export const Phone = MuiPhone
export const Email = MuiEmail
export const Textsms = MuiTextsms
export const LocationOn = MuiLocationOn
export const GetApp = MuiGetApp
export const FilterList = MuiFilterList
export const Help = MuiHelp
export const Mic = MuiMic
export const Star = MuiStar
export const StarBorder = MuiStarBorder
export const Warning = MuiWarning
export const ArrowForward = MuiArrowForward
export const Launch = MuiLaunch
export const TurnedInNot = MuiTurnedInNot
export const UnfoldMore = MuiUnforldMore
export const OpenInNew = MuiOpenInNew
export const ContentCopy = MuiContentCopy
export const Check = MuiCheck
export const East = MuiEast
export const AutoAwesome = MuiAutoAwesome
export const OpenInFullOutlined = MuiOpenInFullOutlined
export const Block = MuiBlock
export const ErrorOutline = MuiErrorOutline
export const LocalShippingOutlined = MuiLocalShippingOutlined
export const NotificationsOutlined = MuiNotificationsOutlined
export const FileDownloadOutlined = MuiFileDownloadOutlined
export const Refresh = MuiRefresh

export type IconType = SvgIconComponent
export type IconProps = SvgIconProps
